<template>
  <div>
    <div v-if="$route.path === '/login' && !isAuthenticated">
        <router-view />
    </div>

    <div v-if="($route.path === '/setup/' || $route.path === '/setup/nylas/complete') && isAuthenticated && !hasNylasValue">
        <router-view />
    </div>

    <div id="app" class="wrap-page" v-if="isAuthenticated && hasNylasValue && $route.path !== '/login' && $route.path !== '/setup/'">
      <Header v-if="$route.name !== 'Logout'"></Header>
      <div class="min-height-50 bg-white top-0 position-fixed w-100 zindex-sticky"></div>
      <div class="min-height-50 top-3r bg-primary position-fixed w-100 zindex-sticky"></div>
      <LeftNavbar v-if="$route.name !== 'Logout'"></LeftNavbar>
      <div class="dark-overlay h-100 w-100"></div>
      <main
        :style="isCollapsed ? 'margin-left: 60px' : ''"
        :class="
          'main-content position-relative border-radius-lg pt-7'
        "
      >
        <div class="container-fluid py-4">
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import LeftNavbar from '@/components/LeftNavbar'
import { authenticationService } from './services/authentication.service'
import { utilService } from './services/util.service'
import { bus } from './main'

export default {
  name: 'App',
  components: { Header, LeftNavbar },
  data () {
    return {
      currentUser: null,
      user: null,
      hasNylasValue: false,
      loading: true,
      isCollapsed: false
    }
  },
  watch: {
    $route (to, from) {
      authenticationService.refresh()
      if (this.currentUser) {
        authenticationService.getAllContentTypes()
      }
    }
  },
  computed: {
    isAuthenticated () {
      return !!this.currentUser
    }
  },

  created () {
    bus.$on('toggleMenu', (data) => {
      this.isCollapsed = !this.isCollapsed
    })

    authenticationService.currentUser.subscribe((x) => {
      this.currentUser = x
      if (x) {
        this.loading = true
        this.$nextTick(() => {
          utilService
            .getCurrentUser()
            .then((user) => {
              if (user && user.profile && user.profile.nylas_access_token) {
                this.hasNylasValue = true
                this.loading = false
                this.$intercom.boot({
                  user_id: user.id,
                  name: `${user.first_name} ${user.last_name}`,
                  email: user.email
                })
                this.$intercom.show()
              } else {
                this.hasNylasValue = false
                console.log('route_name', this.$route)
                if (
                  this.$route.name !== 'SetupProfileComplete' &&
                  this.$route.name !== 'Login' &&
                  this.$route.name !== 'Logout'
                ) {
                  this.$router.push('/setup/')
                }
                this.loading = false
              }
            })
        })
      } else {
        this.loading = false
      }
    })

    authenticationService.refresh()
    if (this.currentUser) {
      authenticationService.getAllContentTypes()
      utilService.getListContact({
        q: 'q=',
        ordering: '',
        limit: '9999999999',
        offset: 0
      })
    }
  }
}
</script>

<style>
@import "./assets/vendor/css/normalize.css";
@import "./assets/vendor/argon/dashboard.css";
@import "./assets/scss/org-tree.scss";
@import "./assets/scss/common.scss";
@import "./assets/scss/main.scss";
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css");
@import "vue-select/dist/vue-select.css";
@import "vue-phone-number-input/dist/vue-phone-number-input.css";
@import "vue-multiselect/dist/vue-multiselect.min.css";
@import "bootstrap-vue/dist/bootstrap-vue.css";
@import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

#app {
  background-color: #f8f8f8;
  min-width: 100vw;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue